import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Button } from 'antd';
import get from 'lodash/get';

import { Link } from 'react-router-dom';
import Table from 'components/Table';
import { FILTER_TYPE, paginationParam } from 'shared/constant';
import NewFilter from 'components/NewFilter';
import { permissionService } from 'shared/services';
import urlUtil from 'shared/utils/UrlUtil';

import text from './TncList.page.translation';
import allBillersRoute from '../../route';
import './TncList.style.less';

const { checkPermission } = permissionService;

class TncList extends PureComponent {
  constructor(props) {
    super(props);
    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount() {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateTncTable(filterValue);
    } else {
      this.updateTncTable([]);
    }
  }

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateTncTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this._handleChangePage(1);
        } else {
          this.updateTncTable(filterValue);
        }
      }
    }
  }

  updateTncTable = filterValue => {
    const { getListTnc, tncFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this._buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...tncFilter,
          page_num: pageInt,
        };
        const paginationUrl = this._buildPaginationUrl(paginationValue);
        getListTnc(paginationUrl, paramUrl, pageInt);
      } else {
        history.push(allBillersRoute.TNC_LIST);
      }
    } else {
      const paginationUrl = this._buildPaginationUrl(paginationValue);
      getListTnc(paginationUrl, paramUrl);
    }
  };

  _buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  _buildPaginationUrl = tncFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(tncFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(tncFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(tncFilter.page_num)}`;

    return result;
  };

  _handleChangePage = page => {
    urlUtil.changePageParams(
      allBillersRoute.TNC_LIST,
      page,
      this.props.history,
    );
  };

  renderCreteTnc = () =>
    checkPermission('Tnc:create', true) && (
      <Button type="primary" block className="btn create-btn" htmlType="submit">
        <Link to={allBillersRoute.TNC_CREATE}>
          {this.props.intl.formatMessage(text.create)}
        </Link>
      </Button>
    );

  _getRowId = row => row.id;

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  renderBreadCrumb = () => (
    <div className="breadcrumb-wrapper">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {this.props.intl.formatMessage(text.title)}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  renderNoColumn = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { tncFilter } = this.props;
    if (tncFilter.page_num === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (tncFilter.page_num - 1) * 10;
    }
    return modifyIndex;
  };

  renderTncName = (name, record) => {
    const link = allBillersRoute.TNC_DETAIL.replace(':id', record.public_id);
    return <Link to={link}>{name}</Link>;
  };

  _tableColumns = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return [
      {
        title: formatMessage(text.table.no),
        key: 'index',
        render: this.renderNoColumn,
        width: 100,
      },
      {
        title: formatMessage(text.table.id),
        dataIndex: 'public_id',
        key: 'public_id',
        width: 150,
      },
      {
        title: formatMessage(text.table.name),
        dataIndex: 'name',
        key: 'name',
        render: this.renderTncName,
        width: 250,
      },
      {
        title: formatMessage(text.table.version),
        dataIndex: 'latest_version_name',
        key: 'latest_version_name',
        width: 200,
      },
    ];
  };

  render() {
    const {
      loading,
      listTnc,
      tncFilter,
      intl: { formatMessage },
    } = this.props;
    const totalItem = tncFilter.page_size * tncFilter.page_count;

    const options = [
      {
        label: formatMessage(text.table.id),
        value: 'public_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.name),
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
    ];

    const tableColumns = this._tableColumns();

    const scrollX = this.getColumnsScrollX(tableColumns);

    return (
      <div className="main-content tnc-list">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          <span className="title mbottom30">{formatMessage(text.title)}</span>

          {this.renderCreteTnc()}
          <NewFilter options={options} />
          <div className="table-wrapper">
            <Table
              bordered
              rowID={this._getRowId}
              rowKey={this._getRowId}
              columns={tableColumns}
              dataSource={listTnc}
              pagination="true"
              rowClass="striped-table"
              loadingValue={loading}
              totalItem={totalItem}
              currentPage={tncFilter.page_num}
              changePage={this._handleChangePage}
              scrollX={scrollX}
            />
          </div>
        </div>
      </div>
    );
  }
}

TncList.propTypes = {
  intl: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  listTnc: PropTypes.array.isRequired,
  tncFilter: PropTypes.object.isRequired,
  resetFilter: PropTypes.func.isRequired,
  getListTnc: PropTypes.func.isRequired,
  filterValue: PropTypes.array.isRequired,
  history: PropTypes.object,
  match: PropTypes.object,
  formControlShow: PropTypes.bool,
};

export default TncList;
